import React from "react";

const TsVenueBannerPerformanceDashboard = ({ loading = false, bannerBreakdown = [] }) => {
  const getBannerLabel = (item) => item.alias || item.name || item.adv_id;
  const totalClicks = bannerBreakdown.reduce((sum, item) => sum + (Number(item.totalCount) || 0), 0);
  const maxCount = bannerBreakdown.length ? bannerBreakdown[0].totalCount : 0;

  return (
    <div className="relative flex flex-col gap-4 rounded-[24px] border border-[#e7ebf8] bg-[linear-gradient(180deg,#ffffff_0%,#fbfcff_100%)] px-6 pb-6 pt-5 shadow-[0_16px_34px_rgba(30,52,120,0.06)]">
      <div>
        <h3 className="mb-1 text-[1.1rem] font-semibold tracking-[-0.02em] text-[#1f2d4d]">Banner Performance</h3>
        <p className="text-sm text-[#6b7894]">Touchscreen banner clicks are tracked independently from digital compendium analytics.</p>
      </div>

      {loading ? (
        <div className="rounded-[18px] border border-[#e6ebf8] bg-[#fbfcff] px-4 py-4 text-sm text-[#7a88a6]">Loading banner performance...</div>
      ) : bannerBreakdown.length === 0 ? (
        <div className="rounded-[18px] border border-[#e6ebf8] bg-[#fbfcff] px-4 py-4 text-sm text-[#7a88a6]">No banner click data available for the selected period.</div>
      ) : (
        <div className="flex flex-col gap-3">
          {bannerBreakdown.map((item, index) => (
            <div key={item.adv_id} className="flex items-start gap-4 rounded-[18px] border border-[#e6ebf8] bg-white px-4 py-3 shadow-[0_10px_20px_rgba(15,23,42,0.04)]">
              <div className="w-8 text-sm font-semibold text-[#7a88a6]">#{index + 1}</div>
              <div className="h-16 w-28 flex-none overflow-hidden rounded-xl border border-[#e6ebf8] bg-[#f7f9fd]">
                {item.image ? (
                  <img src={item.image} alt={`Banner ${item.adv_id}`} className="h-full w-full object-cover" />
                ) : (
                  <div className="flex h-full w-full items-center justify-center text-xs text-[#94a0ba]">No image</div>
                )}
              </div>
              <div className="min-w-0 flex-1">
                <div className="break-words text-sm font-medium leading-snug text-[#1f2d4d]">{getBannerLabel(item)}</div>
                <div className="mt-1 break-words text-xs text-[#7a88a6]">ID: {item.adv_id}</div>
                <div className="mt-1.5 h-1.5 w-full rounded-full bg-[#eef1f8]">
                  <div
                    className="h-1.5 rounded-full bg-[#6d4fc4]"
                    style={{ width: `${maxCount ? Math.max((item.totalCount / maxCount) * 100, 4) : 0}%` }}
                  />
                </div>
              </div>
              <div className="flex-none text-right">
                <div className="text-lg font-semibold text-[#1f2d4d]">{item.totalCount}</div>
                <div className="text-xs text-[#7a88a6]">{totalClicks ? `${((item.totalCount / totalClicks) * 100).toFixed(1)}%` : "0%"} of clicks</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TsVenueBannerPerformanceDashboard;
